module.exports = __webpack_public_path__ + "static/media/picture-min.b4c1a5fa.jpg";